import { useNotify, useRefresh, required, ReferenceInput, SelectInput, Button } from "react-admin";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { candidateRequests } from "api/candidateApi";
import { administrationRequests } from "api/administrationApi";
import dataProvider from "server/dataProvider";
import FormModal from "server/components/Modals/FormModal";

const AddIntermediaryDialog = ({ candidacyId, disabled }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    await dataProvider.customRequest(
      candidateRequests.addCandidacyIntermediary(candidacyId),
      { intermediaryId: data.intermediaryId },
      "POST",
    );
    notify("Успешно добавяне", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Добавяне на представител"
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          disabled={disabled}
          startIcon={<PersonAddIcon />}
          variant="contained"
          size="medium"
          label="Добави"
        />
      }
    >
      <ReferenceInput
        source="intermediaryId"
        reference={administrationRequests.getIntermediariesSelect()}
      >
        <SelectInput
          label="Представител"
          validate={[required()]}
        />
      </ReferenceInput>
    </FormModal>
  );
};

export default AddIntermediaryDialog;
